import POPIcon from "@assets/icons/statTest/POP.svg?react";
import YOYIcon from "@assets/icons/statTest/YOY.svg?react";
import PTPIcon from "@assets/icons/statTest/PTP.svg?react";

export const STAT_TESTING_OPTIONS = [
  {
    id: "POP",
    title: "Period-over-Period",
    icon: <POPIcon height={18} />,
    description: "Current date selection vs prior date selection",
  },
  {
    id: "YOY",
    title: "Year-over-Year",
    icon: <YOYIcon height={18} />,
    isActive: true,
    description: "Current date selection vs same time in prior year",
  },
  {
    id: "PTP",
    title: "Peer-to-Peer",
    icon: <PTPIcon height={18} />,
    description: "Stat testing among the brands of interest",
  },
];
